import axios from "axios";
import { ApiSchemaLanguage } from "../models/api/language";
import { AppRouteApi } from "../config/appRoute";

export class Language {
  private static languages: ApiSchemaLanguage[] = [];

  private constructor() {}

  public static getLanguages(): ApiSchemaLanguage[] {
    return Language.languages;
  }

  public static getLanguageSelectItems() {
    return Language.languages.map((language) => ({
      value: language.name,
      label: language.name,
    }));
  }

  public static fetchLanguages() {
    axios.get<ApiSchemaLanguage[]>(AppRouteApi.Language.Root()).then((res) => {
      Language.languages = res.data;
    });
  }
}
